import React, { useEffect } from 'react';
import styled from 'styled-components';

// Styled Components for the widget
const WidgetContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 200px;
  height: 350px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const TradingViewWidget = styled.div`
  width: 100%;
  height: 100%;
`;

const TradingViewComponent2 = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-hotlists.js';
    script.async = true;
    script.innerHTML = JSON.stringify({
      colorTheme: "light",
      dateRange: "1D",
      exchange: "BSE",
      showChart: false,
      locale: "en",
      width: 450,
      height: 550,
      largeChartUrl: "",
      isTransparent: false,
      showSymbolLogo: true,
      showFloatingTooltip: true
    });

    const widgetContainer = document.querySelector('.tradingview-widget-container__widget');
    widgetContainer.appendChild(script);

    return () => {
      widgetContainer.innerHTML = '';
    };
  }, []);

  return (
    <WidgetContainer>
      <TradingViewWidget className="tradingview-widget-container">
        <div className="tradingview-widget-container__widget"></div>
        
      </TradingViewWidget>
    </WidgetContainer>
  );
};

export default TradingViewComponent2;
